import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatPaginator } from '@angular/material';
import { FileUploader } from 'ng2-file-upload';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { NotaFiscal } from 'src/app/models/nota-fiscal';
import { NotaFiscalOcorrencia } from 'src/app/models/nota-fiscal-ocorrencia';
import { CarregandoService } from 'src/app/services/carregando.service';
import { GlobalService } from 'src/app/services/global.service';
import { NotaFiscalService } from 'src/app/services/nota-fiscal.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { OcorrenciaService } from 'src/app/services/ocorrencia.service';
import { UtilitarioService } from 'src/app/services/utilitario.service';

@Component({
  selector: 'app-cadastrar-nota-fiscal-pedido-modal',
  templateUrl: './cadastrar-nota-fiscal-pedido-modal.component.html',
  styleUrls: ['./cadastrar-nota-fiscal-pedido-modal.component.scss']
})
export class CadastrarNotaFiscalPedidoModalComponent implements OnInit {
  public config: PerfectScrollbarConfigInterface = {};
  nota: NotaFiscal = new NotaFiscal();
  carregando = true;
  editando: boolean = false;
  texto: string = "Adicionar";
  xmlSelecionado: File;
  xmlExibido: string = null;
  xmlDoBanco = false;
  podeSalvar: boolean = false;
  administrador: boolean = false;

  ocorrencia: boolean = false;
  notaOcorrencia: NotaFiscalOcorrencia = new NotaFiscalOcorrencia();
  idOcorrencia: number = null;
  textoOrigem: string = "Notas Fiscais do Pedido";
  tipoOcorrencia = [{ id: 0, descricao: "Venda" }, { id: 1, descricao: "Devolução" }, { id: 2, descricao: "Troca" }, { id: 3, descricao: "Bonificação" }, { id: 4, descricao: "Coleta" }];

  tipoInput: 'manual' | 'xml' = 'manual';

  @ViewChild('paginatorAnexo', { static: false }) paginator: MatPaginator;

  constructor(
    private globalService: GlobalService,
    private utilitarioService: UtilitarioService,
    private notaFiscalService: NotaFiscalService,
    public dialogRef: MatDialogRef<CadastrarNotaFiscalPedidoModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
    private ocorrenciaService: OcorrenciaService
  ) {
    this.nota.nnotaf = data.idCupom;
    this.ocorrencia = data.ocorrencia;
    this.idOcorrencia = data.idOcorrencia;

    if (this.ocorrencia) {
      this.textoOrigem = "Notas Fiscais da Ocorrência"
      this.notaOcorrencia.tipoNota = 0;
    }
  }

  async ngOnInit() {
    this.administrador = await this.globalService.administrador();
  }

  ngAfterViewInit(): void {
    this.utilitarioService.rodaScriptTabEnter();
  }

  onFileChanged(event) {
    this.xmlSelecionado = event.target.files[0];
    this.xmlExibido = this.xmlSelecionado.name;
    this.xmlDoBanco = false;
  }

  baixarXML() {
    this.carregandoService.mostra('baixarXML');

    this.notaFiscalService.baixarXML(this.nota.idNota).subscribe(
      (xml) => {
        this.utilitarioService.saveBlob(xml, this.xmlExibido);

        this.carregandoService.esconde('baixarXML');
      },
      (erro) => {
        this.carregandoService.esconde('baixarXML');
        this.notificacaoService.erro(erro);
      });
  }

  selecionarTipoInput(tipo: 'manual' | 'xml') {
    this.tipoInput = tipo;
  }

  salvar() {
    if ((this.tipoInput === 'xml' && this.xmlSelecionado == null && this.xmlSelecionado == undefined) || (!this.ocorrencia && (this.nota.obs.length == 0 || this.nota.obs.trim() == ''))) {
      this.notificacaoService.erro('É preciso selecionar um arquivo xml e descrever o tipo de nota para salva.')
      return;
    }

    this.carregandoService.mostra('salvaXMLNota');

    const dados = new FormData();

    if (!this.ocorrencia) {
      if (this.xmlDoBanco) {
        dados.append('notaFiscal[nome]', this.nota.nome);
      } else {
        dados.append('notaFiscal[xml]', this.xmlSelecionado);
        dados.append('notaFiscal[nome]', this.xmlSelecionado.name);
      }

      dados.append('notaFiscal[obs]', this.nota.obs);
      dados.append('notaFiscal[nnotaf]', this.nota.nnotaf);
      dados.append('notaFiscal[mostrarNaOcorrencia]', this.nota.mostrarNaOcorrencia ? 'true' : 'false');
      dados.append('notaFiscal[fatura]', this.nota.fatura ? 'true' : 'false');

      this.notaFiscalService.salvar(dados).subscribe(() => {
        this.notificacaoService.sucesso('XML salvo com sucesso!!!');
        this.carregandoService.esconde('salvaXMLNota');
        this.dialogRef.close(true);
      }, (erro) => {
        this.carregandoService.esconde('salvaXMLNota');
        this.notificacaoService.erro(erro);
      });
    } else {
      dados.append('notaFiscal[xml]', this.xmlSelecionado);

      dados.append('notaFiscal[idOcorrencia]', this.idOcorrencia.toString());
      dados.append('notaFiscal[tipoNota]', this.notaOcorrencia.tipoNota.toString());
      dados.append('notaFiscal[tipoInput]', this.tipoInput === "xml" ? '1' : '0');

      if (!this.xmlExibido) {
        dados.append('notaFiscal[numeroNota]', this.notaOcorrencia.numeroNota.toString());
        dados.append('notaFiscal[valor]', this.notaOcorrencia.valor.toString().replace(".", ","));
        dados.append('notaFiscal[dataEmissao]', this.notaOcorrencia.dataEmissao.toDateString());
      }

      this.ocorrenciaService.salvarNotaFiscalOcorrencia(dados).subscribe(() => {
        this.notificacaoService.sucesso('XML salvo com sucesso!!!');
        this.carregandoService.esconde('salvaXMLNota');
        this.dialogRef.close(true);
      }, (erro) => {
        this.carregandoService.esconde('salvaXMLNota');
        this.notificacaoService.erro(erro);
      });
    }
  }

  excluirXML() {
    this.xmlSelecionado = null;
    this.xmlExibido = '';
  }

  fechar() {
    this.dialogRef.close();
  }
}
